import { AxiosRequestConfig, AxiosResponse } from "axios";
import { Api } from "./Api";
import { apiConfig } from "../config/apiConfig";
import { LocationTokenResponse } from "../model/response";

/*
 * Interfaces with our backend
 */
class LocationAuthApi extends Api {
  public constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig);

    this.getAccessToken = this.getAccessToken.bind(this);
  }

  public getAccessToken = () => this.post("/location/token", [])  as Promise<AxiosResponse<LocationTokenResponse>>;

}

export const locationAuthApi = new LocationAuthApi(apiConfig);
